import { combineReducers } from "redux";

import users from "./users/reducer";
import configs from "./configs/reducer";
import snackbar from "./snackbar/reducer";
import loadingFull from "./loadingFull/reducer";

export default combineReducers({
  users,
  configs,
  snackbar,
  loadingFull,
});
